"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkingHoursConverter = void 0;
const date_fns_1 = require("date-fns");
const lodash_1 = require("lodash");
const dateCoder_1 = require("./dateCoder");
const index_1 = require("./index");
const isHoliday_1 = require("./isHoliday");
// WorkingHourをPeriodsに変換する
class WorkingHoursConverter {
    static convert({ workingHours, start, end, nationalHolidays }) {
        // 日付毎のPeriods[]を算出
        const periods = (0, date_fns_1.eachDayOfInterval)({ start, end }).map((date) => {
            if ((0, isHoliday_1.isHoliday)(date, nationalHolidays)) {
                // 祝日の場合
                const holidayWorkingHours = workingHours ? workingHours['hol'] : null;
                return this.convertDailyWorkingHours(holidayWorkingHours, date);
            }
            else {
                // 祝日でない場合
                // 日付の曜日を取得
                const key = (0, dateCoder_1.formatEnDayName)(date).toLowerCase();
                // 曜日の設定値と日付からPeriodの配列を取得
                // (設定していないユーザーの場合nullが返る)
                const dayName = key;
                const dailyWorkingHours = workingHours ? workingHours[dayName] : null;
                return this.convertDailyWorkingHours(dailyWorkingHours, date);
            }
        });
        return new index_1.Periods((0, lodash_1.flatten)(periods));
    }
    static convertDailyWorkingHours(dailyWorkingHours, date) {
        if (dailyWorkingHours == null) {
            return [new index_1.Period((0, date_fns_1.startOfDay)(date), (0, date_fns_1.endOfDay)(date))];
        }
        if (!dailyWorkingHours.available) {
            return [];
        }
        const periods = dailyWorkingHours.times.map((time) => {
            return new index_1.Period((0, date_fns_1.set)(date, { hours: time.startTime.hour, minutes: time.startTime.min }), (0, date_fns_1.set)(date, { hours: time.endTime.hour, minutes: time.endTime.min }));
        });
        return periods;
    }
}
exports.WorkingHoursConverter = WorkingHoursConverter;
//# sourceMappingURL=workingHourConverter.js.map